import { useNavigate } from 'react-router-dom'

import { TimeoffPolicyAddEmployeeModalPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import AddEmployeeModal from 'modules/timeoff/components/TimeoffPolicy/AddEmployee'
import AddEmployeeAssignmentModal from 'modules/timeoff/components/TimeoffPolicy/AddEmployeeAssignment'
import { hasPolicyTemporality } from 'modules/timeoff/lib/features/TimeoffFeatures'

const AddEmployeeModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()
  const timeoffPolicyId = String(id)
  const isPolicyTemporality = hasPolicyTemporality()

  const { data, loading } = useQuery(TimeoffPolicyAddEmployeeModalPageDocument, {
    variables: {
      timeoffPolicyId,
    },
    skip: isPolicyTemporality,
  })

  const onClose = () => {
    navigate(navigation.settings.timeoffPolicies.id.employees.fullPath({ id }))
  }

  if (isPolicyTemporality) {
    return (
      <AddEmployeeAssignmentModal loading={false} timeoffPolicyId={String(id)} onClose={onClose} />
    )
  }

  const timeoffPolicyAllowances = data?.timeoff.allowances ?? []

  return (
    <AddEmployeeModal
      loading={loading}
      timeoffPolicyId={timeoffPolicyId}
      timeoffPolicyAllowances={timeoffPolicyAllowances}
      onClose={onClose}
    />
  )
}

export default AddEmployeeModalPage
